import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Flex,
  FormField,
  Modal,
  TextInput,
  Select,
} from '../../../components';
import api from '../../../utils/services';

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  planId: PropTypes.number.isRequired,
  onBenefitAdded: PropTypes.func.isRequired,
  typeDropDownOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  benefitCategoryDropDownOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
};

// TODO general error handleing
export default class NewBenefit extends Component {
  constructor(props) {
    super(props);
    this.state = this.baseState();
  }

  baseState = () => ({
    name: '',
    value: '',
    type: '',
    category: '',
    subcategory: '',
    benefitCategory: '',
  })

  handleChange = (event) => {
    const { target: { name, value } } = event;

    this.setState({
      [name]: value,
    });
  }

  handleSelectChange = (name, value) => this.handleChange({ target: { name, value } })

  handleSubmit = () => {
    const { planId, onClose, onBenefitAdded } = this.props;
    const createBody = { planId, ...this.state };
    api.addPlanBenefit(createBody)
      .then((data) => {
        // Clear state in case it is opened again
        this.setState(this.baseState());
        onClose();
        onBenefitAdded(data);
      }).catch(() => {
        // TODO, display the error instead
        console.log('An error occurred. Please try again.');
      });
  }

  render() {
    const {
      isOpen,
      onClose,
      typeDropDownOptions,
      benefitCategoryDropDownOptions,
    } = this.props;
    const benefit = this.state;
    return (
      <Modal
        title="Add Benefit"
        isOpen={isOpen}
        onClose={onClose}
      >
        <Modal.Body>
          <FormField
            label="Name"
            input={TextInput}
            name="name"
            value={benefit.name}
            onChange={this.handleChange}
          />
          <FormField
            label="Value"
            input={TextInput}
            name="value"
            value={benefit.value}
            onChange={this.handleChange}
          />
          <FormField
            label="Type"
            input={Select}
            name="type"
            value={benefit.type}
            placeholder="Select Type"
            data={typeDropDownOptions}
            onChange={item => this.handleSelectChange('type', item.value)}
          />
          <FormField
            label="Category"
            input={TextInput}
            name="category"
            value={benefit.category}
            onChange={this.handleChange}
          />
          <FormField
            label="Subcategory"
            input={TextInput}
            name="subcategory"
            value={benefit.subcategory}
            onChange={this.handleChange}
          />
          <FormField
            label="Benefit Category"
            input={Select}
            name="benefitCategory"
            value={benefit.benefitCategory}
            placeholder="Select Benefit Category"
            data={benefitCategoryDropDownOptions}
            onChange={item => this.handleSelectChange('benefitCategory', item.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Flex gutterWidth="0.5em">
            <Flex.Item>
              <Button onClick={onClose}>Cancel</Button>
            </Flex.Item>
            <Flex.Item>
              <Button primary onClick={this.handleSubmit}>Save</Button>
            </Flex.Item>
          </Flex>
        </Modal.Footer>
      </Modal>
    );
  }
}

NewBenefit.propTypes = propTypes;
